export default __webpack_public_path__ + "static/media/piano6.e35e40eb.png";